"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceTypesArray = void 0;
exports.serviceTypesArray = ["pcr", "pcr_express", "vacuna_antigripal", "hisopado_antigeno", "guardia", "antigenos", "especialista", "subscriptions", "chatAtt", "quickPrescription", "especialista_salud_mental", "aptofisico_certificate", "aptofisico_orders", "aptofisico_orders_certificate"];
